export const BASE_EKATA_URL = 'https://app.ekata.com'

export const EKATA_IDENTITY_REVIEW_URL = `${BASE_EKATA_URL}/identity_reviews`
export const EKATA_EMAIL_SEARCH_URL = `${BASE_EKATA_URL}/emails`
export const EKATA_PHONE_SEARCH_URL = `${BASE_EKATA_URL}/phones`
export const EKATA_ADDRESS_SEARCH_URL = `${BASE_EKATA_URL}/addresses`

/**
 * Supported Ekata Identity Review 360 deep link fields, per Ekata's
 * "Update Deep Link to POST Method" technical guide.
 *
 * see https://signifyd.atlassian.net/browse/FET-4091
 */
export interface EkataIdentityReviewVariables {
  billing_name?: string
  billing_phone?: string
  billing_phone_country_hint?: string
  billing_address_city?: string
  billing_address_country_code?: string
  billing_address_line_1?: string
  billing_address_line_2?: string
  billing_address_location?: string
  billing_address_postal_code?: string
  billing_address_state_code?: string
  billing_address_street_line_1?: string
  billing_address_street_line_2?: string
  shipping_name?: string
  shipping_phone?: string
  shipping_phone_country_hint?: string
  shipping_address_city?: string
  shipping_address_country_code?: string
  shipping_address_line_1?: string
  shipping_address_line_2?: string
  shipping_address_location?: string
  shipping_address_postal_code?: string
  shipping_address_state_code?: string
  shipping_address_street_line_1?: string
  shipping_address_street_line_2?: string
  email_address?: string
  ip_address?: string
  transaction_id?: string
  phone?: string
}

export interface EkataPhoneSearchVariables {
  number?: string
}

export interface EkataEmailSearchVariables {
  email?: string
}

export interface EkataAddressSearchVariables {
  street?: string
  where?: string
  country_code?: string
}

type EkataSearchFormParams =
  | EkataPhoneSearchVariables
  | EkataEmailSearchVariables
  | EkataAddressSearchVariables
  | EkataIdentityReviewVariables

const submitEkataPostForm = (
  action: string,
  params: EkataSearchFormParams
): void => {
  const form = document.createElement('form')
  form.method = 'post'
  form.action = action
  form.target = '_blank'

  Object.entries(params).forEach(([name, value]) => {
    if (!value) {
      return
    }

    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  })

  document.body.appendChild(form)

  try {
    form.submit()
  } finally {
    document.body.removeChild(form)
  }
}

export const openEkataIdentityReview = (
  params: EkataIdentityReviewVariables
): void => {
  submitEkataPostForm(EKATA_IDENTITY_REVIEW_URL, params)
}

export const openEkataPhoneSearch = (
  params: EkataPhoneSearchVariables
): void => {
  submitEkataPostForm(EKATA_PHONE_SEARCH_URL, params)
}

export const openEkataEmailSearch = (
  params: EkataEmailSearchVariables
): void => {
  submitEkataPostForm(EKATA_EMAIL_SEARCH_URL, params)
}

export const openEkataAddressSearch = (
  params: EkataAddressSearchVariables
): void => {
  submitEkataPostForm(EKATA_ADDRESS_SEARCH_URL, params)
}
